import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CourseService } from 'src/app/shared/services/course.service';
import { jsPDF } from 'jspdf';

@Component({
  selector: 'app-courses-schedule',
  templateUrl: './courses-schedule.component.html',
  styleUrls: ['./courses-schedule.component.scss']
})
export class CoursesScheduleComponent implements OnInit {
  selectedCourse = null;
  schedule: any[] = [];
  filteredSchedule: any[] = [];
  searchText: string = '';
  loader = false;
  memberships: any[] = [];
  courses: any = [
    {
      "courseID": 115014, 
      "courseName": "USMLE Step 1"
    },
    {
      "courseID": 115015, 
      "courseName": "USMLE Step 2 CK"
    },
    {
      "courseID": 135631, 
      "courseName": "USMLE Step 3"
    }
  ]
  isDemo = false;

  constructor(private courseService: CourseService, private authService: AuthService) { }

  async ngOnInit(): Promise<void> {
    if (this.courses.length > 0) {
      this.selectedCourse = this.courses[0].courseID;
    }
    if (localStorage.getItem('Id')=='-1') {
      this.isDemo = true;
    }
    this.loader = true;
    await this.getUserSubscription();
    this.loadSchedule();
  }

  getUserSubscription() {
    return new Promise((resolve, reject) => {
      this.authService.getUserSubscription().subscribe((res: any) => {
        this.memberships = res.subscriptions.filter(item => item.Status == 'active' || item.Status == 'expired')
        resolve(true);
      }, (error) => {
        this.loader = false;
        resolve(false);
      })
    })
  }

  changeCourse() {
    this.schedule = [];
    this.filteredSchedule = [];
    this.loader = true;
    this.loadSchedule();
  }

  loadSchedule() {
    if (this.selectedCourse) {
      let isPremium = false;
      for (let i = 0; i < this.memberships.length; i++) {
        if (this.selectedCourse === 115014 && (this.memberships[i].MembershipID === 1 || this.memberships[i].MembershipID === 5) || this.memberships[i].MembershipID === 11 || this.memberships[i].MembershipID === 12) {
          isPremium = true;
          break;
        }
        if (this.selectedCourse === 115015 && (this.memberships[i].MembershipID === 7 || this.memberships[i].MembershipID === 10) || this.memberships[i].MembershipID === 11 || this.memberships[i].MembershipID === 12) {
          isPremium = true;
          break;
        }
        if (this.memberships[i].MembershipID === 17) {
          isPremium = true;
          break;
        }
      }

      if (isPremium || this.isDemo) {
        this.courseService.getCourseScheduleByCourseId(this.selectedCourse).subscribe({
          next: (response: any) => {
            this.loader = false;
            if (response.data.courseSchedule) {
              this.schedule = response.data.courseSchedule;
              this.filterSchedule();
            }
          },
          error: (error) => {
            this.loader = false;
            console.error('Error loading schedule:', error);
            this.schedule = [];
            this.filteredSchedule = [];
          }
        });
      } else {
        this.loader = false;
      }
    } else {
      this.loader = false;
    }
  }

  filterSchedule() {
    if (!this.searchText) {
      this.filteredSchedule = this.schedule;
      return;
    }
    const searchLower = this.searchText.toLowerCase();
    this.filteredSchedule = this.schedule.map(subject => {
      const matchingSystems = subject.systems.filter(system => 
        system.name.toLowerCase().includes(searchLower) ||
        system.content.toLowerCase().includes(searchLower)
      );
      return {
        ...subject,
        systems: matchingSystems
      };
    }).filter(subject => subject.systems.length > 0);
  }

  getTotalDuration(systems: any[]): string {
    let totalMinutes = 0;
    systems.forEach(system => {
      totalMinutes += (system.hours * 60) + system.minutes;
    });
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}m`;
  }

  getSystemDuration(system: any): string {
    return `${system.hours}h ${system.minutes}m`;
  }

  getContentList(content: string): string[] {
    if (!content) return [];
    return content.split('\n').filter(item => item.trim());
  }

  highlightText(text: string): string {
    if (!this.searchText) return text;
    const search = this.searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return text.replace(new RegExp(search, 'gi'), match => `<span class='highlight'>${match}</span>`);
  }

  async downloadPDF(): Promise<void> {
    try {
      const selectedCourseName = this.courses.find(c => c.courseID === this.selectedCourse)?.courseName || 'Course';
      const filename = `${selectedCourseName}_Schedule.pdf`;
      
      // Create PDF instance
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      let yPosition = 20;
      
      // Add header
      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');
      pdf.text(`${selectedCourseName} - Course Schedule`, pageWidth / 2, yPosition, { align: 'center' });
      
      yPosition += 15;
      
      // Add generation date
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      pdf.text(`Generated on: ${new Date().toLocaleDateString()}`, pageWidth / 2, yPosition, { align: 'center' });
      
      yPosition += 20;
      
      // Table headers
      pdf.setFontSize(12);
      pdf.setFont('helvetica', 'bold');
      const headers = ['System', 'Subject', 'Content', 'Sessions', 'Duration'];
      const colWidths = [30, 40, 80, 20, 20];
      let xPosition = 10;
      
      // Draw header row
      pdf.setFillColor(248, 249, 250);
      pdf.rect(10, yPosition - 5, pageWidth - 20, 10, 'F');
      
      headers.forEach((header, index) => {
        pdf.text(header, xPosition + colWidths[index] / 2, yPosition, { align: 'center' });
        xPosition += colWidths[index];
      });
      
      yPosition += 15;
      
      // Add table data
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(10);
      
      for (const subject of this.filteredSchedule) {
        // Check if we need a new page
        if (yPosition > pageHeight - 50) {
          pdf.addPage();
          yPosition = 20;
        }
        
        // System row
        pdf.setFont('helvetica', 'bold');
        xPosition = 10;
        
        // Draw system name cell
        pdf.text(subject.name, xPosition + colWidths[0] / 2, yPosition, { align: 'center', maxWidth: colWidths[0] - 2 });
        xPosition += colWidths[0];
        
        // Empty cells for subject and content
        xPosition += colWidths[1] + colWidths[2];
        
        // Sessions count
        pdf.text(subject.systems.length.toString(), xPosition + colWidths[3] / 2, yPosition, { align: 'center' });
        xPosition += colWidths[3];
        
        // Total duration
        pdf.text(this.getTotalDuration(subject.systems), xPosition + colWidths[4] / 2, yPosition, { align: 'center' });
        
        yPosition += 10;
        
        // Add systems
        pdf.setFont('helvetica', 'normal');
        for (const system of subject.systems) {
          if (yPosition > pageHeight - 30) {
            pdf.addPage();
            yPosition = 20;
          }
          
          xPosition = 10 + colWidths[0]; // Skip system column for sub-rows
          
          // Subject name
          const subjectLines = pdf.splitTextToSize(system.name, colWidths[1] - 2);
          pdf.text(subjectLines, xPosition + 2, yPosition);
          xPosition += colWidths[1];
          
          // Content - Parse HTML list and format as bullet points
          const contentText = this.parseHtmlListForPDF(system.content);
          const contentLines = pdf.splitTextToSize(contentText, colWidths[2] - 4);
          pdf.text(contentLines, xPosition + 2, yPosition);
          xPosition += colWidths[2];
          
          // Skip sessions column
          xPosition += colWidths[3];
          
          // Duration
          pdf.text(this.getSystemDuration(system), xPosition + colWidths[4] / 2, yPosition, { align: 'center' });
          
          // Calculate line height based on content
          const maxLines = Math.max(subjectLines.length, contentLines.length, 1);
          yPosition += maxLines * 5 + 5;
        }
        
        yPosition += 5; // Extra space between subjects
      }
      
      // Save the PDF
      pdf.save(filename);
      
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Error generating PDF. Please try again.');
    }
  }

  private parseHtmlListForPDF(htmlContent: string): string {
    if (!htmlContent) return '';
    
    // Create a temporary div to parse HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
    
    // Find all li elements
    const listItems = tempDiv.querySelectorAll('li');
    const bulletPoints: string[] = [];
    
    listItems.forEach(li => {
      const text = li.textContent?.trim();
      if (text) {
        bulletPoints.push(`• ${text}`);
      }
    });
    
    // If no list items found, just strip HTML tags
    if (bulletPoints.length === 0) {
      return htmlContent.replace(/<[^>]*>/g, '').trim();
    }
    
    return bulletPoints.join('\n');
  }
}
